"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DisplayForRole = require("./DisplayForRole");
Object.keys(_DisplayForRole).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DisplayForRole[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DisplayForRole[key];
    }
  });
});